export enum TooltipTrigger {
    Hover = 'hover',
    Click = 'click',
}
